import { IconComponent } from './types';

const CopyIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <rect
      width={7.182}
      height={7.182}
      x={10.682}
      y={10.682}
      stroke="currentColor"
      rx={1.5}
      transform="rotate(180 10.682 10.682)"
    />
    <path
      stroke="currentColor"
      d="M3.727 8.272H2.5a1.5 1.5 0 0 1-1.5-1.5V2.5A1.5 1.5 0 0 1 2.5 1h4.272a1.5 1.5 0 0 1 1.5 1.5v1.227"
    />
  </svg>
);
export default CopyIcon;
